<template>
  <div class="content">
    <settings-menu></settings-menu>
    <div class="settings-body">
      <div class="settings-body-inner">

        <div class="row">
          <div class="col-md-7">
            <div class="s-block">
              <div class="s-block-header">Your Profile</div>
              <div class="s-block-body" v-if="adminInfo">
                <div class="profile-img-wrap">

                  <div class="profile-img" :class="{'profile-img-added': adminInfo.profile_photo}">
                    <div v-if="!isPhotoUploading">
                      <span class="text-gray-400" v-if="!adminInfo.profile_photo">
                        <font-awesome-icon :icon="['fas', 'camera']"/>
                        <br><span>Add Photo</span>
                      </span>
                      <input type="file" @change="onAvatarChanged" ref="avatarFile" accept="image/*">
                      <img v-if="adminInfo.profile_photo" :src="adminInfo.profile_photo" alt="">
                    </div>

                    <div v-if="isPhotoUploading" class="avatar-loading">
                      <font-awesome-icon class="text-primary" spin :icon="['fas', 'spinner']"/>
                    </div>
                  </div>
                  <div class="label">Profile Picture</div>
                  <a v-if="adminInfo.profile_photo"
                     href="#"
                     v-on:click.prevent="$refs.avatarFile.click()"
                  >Edit/Change</a>
                </div>
                <div class="profile-info">
                  <div class="row row-form">
                    <div class="col-md-6">
                      <div class="form-item">
                        <label>First Name</label>
                        <input type="text" class="form-control" placeholder="First Name" v-model="firstName">
                        <div class="error-msg">wDEF</div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-item">
                        <label>Last Name</label>
                        <input type="text" class="form-control" placeholder="Last Name" v-model="lastName">
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-item">
                        <label>Tell us about yourself</label>
                        <textarea class="form-control"
                                  rows="3"
                                  placeholder="This is a bio about myself that is just showing what it looks like when it’s added to this block."
                                  v-model="description"
                        ></textarea>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-item">
                        <label>Email Address</label>
                        <input type="text" class="form-control" placeholder="" :value="adminInfo.email" readonly>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-item">
                        <label>Phone Number</label>
                        <input type="text" class="form-control" placeholder="(555) 555-5555" v-model="phoneNumber">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-5">
            <div class="s-block">
              <div class="s-block-header">More Details</div>
              <div class="s-block-body" v-if="adminInfo">
                <div class="row row-form">
                  <div class="col-md-12">
                    <div class="form-item">
                      <label>Your Position/Role</label>
                      <input type="text" class="form-control" placeholder="Position/Title" v-model="role">
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="form-item">
                      <label>Permissions</label>
                      <input type="text" class="form-control" placeholder="Administrator" value="Administrator"
                             readonly>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="form-item">
                      <label>Social Profiles</label>
                      <div class="input-group">
                        <span class="input-group-addon input-group-twitter">
                          <font-awesome-icon :icon="['fab', 'twitter']"/>
                        </span>
                        <input type="text"
                               class="form-control"
                               placeholder="@twitterusername"
                               v-model="twitter"
                        >
                      </div>
                      <div class="input-group">
                        <span class="input-group-addon input-group-facebook">
                          <font-awesome-icon :icon="['fab', 'facebook-f']"/>
                        </span>
                        <input type="text"
                               class="form-control"
                               placeholder="https://facebook.com/username"
                               v-model="facebook"
                        >
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div v-if="isEdited" class="settings-btn-bottom">
        <div class="text-right btn-wrap">
          <a href="#" v-on:click.prevent="updateAdminInfo" class="btn btn-sm btn-cancel">Cancel</a>
          <a href="#" v-on:click.prevent="saveAdminInfo" class="btn btn-sm btn-sm-edit">Save</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getUploadUriAndToken,
    uploadImage,
    confirmPhotoUploaded,
    putProfileSettings,
  } from '@/utils/api';
  import SettingsMenu from './menu.vue';
  import {mapState} from "vuex";

  export default {
    name: 'Account',
    mounted() {
      this.updateAdminInfo();
    },
    metaInfo: {
      title: 'Settings - Account',
    },
    components: {
      SettingsMenu,
    },
    methods: {
      checkPhotoLoading() {
        this.$store.dispatch('auth/fetchProfileSettings', {charityId: this.activeCharityId});
      },
      saveAdminInfo() {
        putProfileSettings({
          "first_name": this.firstName,
          "last_name": this.lastName,
          "details": {
            "phone_number": this.phoneNumber,
            "description": this.description,
            "role": this.role,
            "facebook": this.facebook,
            "twitter": this.twitter
          }
        }).then(() => {
          this.$message('Account settings updated');
          this.$store.dispatch('auth/fetchProfileSettings', {charityId: this.activeCharityId})
        });
      },
      onAvatarChanged(e) {
        const file = e.target.files[0];
        if (file) {
          this.isPhotoUploading = true;
          getUploadUriAndToken().then(uploadInfo => {
            uploadImage(uploadInfo.uploadUrl, file).then(() => {
              confirmPhotoUploaded(uploadInfo.imageId).then(() => {

                this.checkPhotoLoading();
              }).catch(() => this.isPhotoUploading = false);
            }).catch(() => this.isPhotoUploading = false);
          }).catch(() => this.isPhotoUploading = false);
        }
      },
      updateAdminInfo() {
        if (this.adminInfo) {
          this.isPhotoUploading = false;

          this.firstName = this.adminInfo.first_name || '';
          this.lastName = this.adminInfo.last_name || '';
          this.description = this.adminInfo.details.description || '';
          this.phoneNumber = this.adminInfo.details.phone_number || '';
          this.role = this.adminInfo.details.role || '';
          this.twitter = this.adminInfo.details.twitter || '';
          this.facebook = this.adminInfo.details.facebook || '';
        }
      },
    },
    computed: {
      ...mapState({
        activeCharityId: state => state.auth.activeCharityId,
        adminInfo: state => state.auth.adminInfo,
      }),
      isEdited() {
        if (this.adminInfo) {
          if ((this.adminInfo.first_name || '') !== this.firstName
            || (this.adminInfo.last_name || '') !== this.lastName
            || (this.adminInfo.details.description || '') !== this.description
            || (this.adminInfo.details.phone_number || '') !== this.phoneNumber
            || (this.adminInfo.details.role || '') !== this.role
            || (this.adminInfo.details.twitter || '') !== this.twitter
            || (this.adminInfo.details.facebook || '') !== this.facebook
          ) {
            return true;
          }
          //check all properties
        }
        return false;
      },
    },
    watch: {
      'adminInfo'() {
        this.updateAdminInfo();
      },
    },
    data() {
      return {
        isPhotoUploading: false,
        firstName: '',
        lastName: '',
        description: '',
        phoneNumber: '',
        role: '',
        twitter: '',
        facebook: '',
      };
    },
  };
</script>
